<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="角色名称">
              <a-input v-model="filterForm.role_name" placeholder="角色名称" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="Code">
              <a-input v-model="filterForm.role_code" placeholder="Code" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="类型">
              <a-select v-model="filterForm.role_type" style="width: 100%" class="form-model-item" placeholder="角色类型" @change="onSearch">
                <a-select-option v-for="(item, key) in roleTypes" :key="key" :value="item.value"> {{ item.label }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="getRoleList">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="角色列表" size="small" class="filter-data">
      <span slot="extra">
        <a-button v-has="{ code: 'system:role:add', project: 0 }" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="role_id" @change="handlePageChange">
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:role:edit', project: 0 }" @click="onEdit(record.role_id)">编辑</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:role:delete', project: 0 }" @click="onDelete(record.role_id)">删除</a>
        </span>
        <span slot="roleType" slot-scope="text, record">
          <a-tag :color="roleTypes[record.role_type].color"> {{ roleTypes[record.role_type].label }} </a-tag>
        </span>
      </a-table>
    </a-card>
    <role-drawer :visible="drawerVisible" :role-id="roleId" @close="close" />
  </div>
</template>

<script>
import RoleDrawer from '@/pages/system/components/RoleDrawer';
import { roleList, roleDelete } from '@/api/system/auth';
import { roleTypes } from '@/utils/dictionary';
const columns = [
  {
    title: '角色ID',
    dataIndex: 'role_id',
    key: 'role_id',
    align: 'center'
  },
  {
    title: '角色名称',
    dataIndex: 'role_name',
    key: 'role_name'
  },
  {
    title: '角色标识',
    dataIndex: 'role_code',
    key: 'role_code'
  },
  {
    title: '类型',
    dataIndex: 'role_type',
    key: 'role_type',
    scopedSlots: { customRender: 'roleType' }
  },
  {
    title: '备注',
    key: 'description',
    dataIndex: 'description'
  },
  {
    title: '创建时间',
    key: 'created_time',
    align: 'center',
    width: 180,
    dataIndex: 'created_time'
  },
  {
    title: '修改时间',
    key: 'updated_time',
    align: 'center',
    width: 180,
    dataIndex: 'updated_time'
  },
  {
    title: '操作',
    align: 'center',
    width: 140,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  components: {
    RoleDrawer
  },
  data() {
    return {
      loading: false,
      roleTypes,
      filterForm: {
        role_name: null,
        role_code: null,
        role_type: null,
        page_size: null,
        page_number: null
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      drawerVisible: false,
      roleId: null,
      tableData: [],
      columns
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    }
  },
  created() {
    this.getRoleList();
  },
  methods: {
    onAdd() {
      this.roleId = null;
      this.drawerVisible = true;
    },
    onEdit(id) {
      this.roleId = id;
      this.drawerVisible = true;
    },
    getRoleList() {
      this.loading = true;
      roleList(this.filterForm)
        .then(response => {
          this.tableData = response.data.roles;
          this.pagination.total = response.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onDelete(id) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该角色吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          roleDelete({ role_id: id, project_id: self.projectId }).then(() => {
            self.$message.success('删除成功');
            self.getRoleList();
          });
        }
      });
    },
    onReset() {
      this.filterForm.role_name = null;
      this.filterForm.role_code = null;
      this.filterForm.page_number = 1;
      this.getRoleList();
    },
    onSearch() {
      this.filterForm.page_number = 1;
      this.getRoleList();
    },

    handlePageChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getRoleList();
    },

    close() {
      this.drawerVisible = false;
      this.getRoleList();
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
</style>
